import {
  BundleBasketFragment,
  ProductType,
  QuoteUnavailabilityReasonType,
  Status,
} from '@generated/gql/graphql';

const hasExpiredBundle = (basket: BundleBasketFragment): boolean =>
  basket.quotes.some(
    ({ status: { status, reasons }, selected, product: { type } }) =>
      status === Status.Unavailable &&
      reasons?.some(
        ({ type }) => type === QuoteUnavailabilityReasonType.Expired
      ) &&
      selected &&
      type !== ProductType.Energy
  );

export { hasExpiredBundle };
